import React, { useState, useEffect, useContext, useRef, useMemo } from "react";
import withWidth, { isWidthUp } from "@material-ui/core/withWidth";
import "emoji-mart/css/emoji-mart.css";
import { Picker } from "emoji-mart";
import MicRecorder from "mic-recorder-to-mp3";
import clsx from "clsx";
import { isNil } from "lodash";
import { Reply } from "@material-ui/icons";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import InputBase from "@material-ui/core/InputBase";
import CircularProgress from "@material-ui/core/CircularProgress";
import { grey } from "@material-ui/core/colors";
import { BORDERS, SHADOWS, TRANSITION, CHAT } from "../../theme/redesign";
// import AttachFileIcon from "@material-ui/icons/AttachFile"; // ✅ YA NO SE USA - REEMPLAZADO POR AddIcon
import AddIcon from "@material-ui/icons/Add";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import DescriptionIcon from "@material-ui/icons/Description";
import PhotoCameraIcon from "@material-ui/icons/PhotoCamera";
import MicIcon from "@material-ui/icons/Mic";
import ContactPhoneIcon from "@material-ui/icons/ContactPhone";
import IconButton from "@material-ui/core/IconButton";
import MoodIcon from "@material-ui/icons/Mood";
import SendIcon from "@material-ui/icons/Send";
import ClearIcon from "@material-ui/icons/Clear";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import CloseIcon from "@material-ui/icons/Close";
import FlashOnIcon from "@material-ui/icons/FlashOn";
import FolderIcon from "@material-ui/icons/Folder";
import { FormControlLabel, Switch, Box, Typography, Divider, TextField, Button } from "@material-ui/core";
import LockIcon from "@material-ui/icons/Lock";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { isString, isEmpty, isObject, has } from "lodash";

import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import axios from "axios";

import RecordingTimer from "./RecordingTimer";
import { ReplyMessageContext } from "../../context/ReplyingMessage/ReplyingMessageContext";
import { ForwardMessageContext } from "../../context/ForwarMessage/ForwardMessageContext";
import { AuthContext } from "../../context/Auth/AuthContext";
import { SocketContext } from "../../context/Socket/SocketContext";
import { useLocalStorage } from "../../hooks/useLocalStorage";
import toastError from "../../errors/toastError";
import { toast } from "react-toastify";

import Compressor from 'compressorjs';

const IMAGE_EXT = /\.(jpe?g|png|gif|webp|bmp|heic|heif)$/i;

const guessMimeFromName = (name = "") => {
  const ext = String(name).split(".").pop()?.toLowerCase();
  const map = {
    jpg: "image/jpeg",
    jpeg: "image/jpeg",
    png: "image/png",
    gif: "image/gif",
    webp: "image/webp",
    bmp: "image/bmp",
    heic: "image/heic",
    heif: "image/heif",
  };
  return map[ext] || "";
};

const isEmptyMime = (type) => {
  const mime = String(type || "").toLowerCase();
  return !mime || mime === "application/octet-stream" || mime === "binary/octet-stream";
};

const isChatImage = (file) => {
  if (!file) return false;
  const type = String(file.type || "").toLowerCase();
  if (type.startsWith("image/")) return true;
  return IMAGE_EXT.test(file.name || "");
};

const sniffImageMime = async (file) => {
  try {
    const buf = new Uint8Array(await file.slice(0, 16).arrayBuffer());
    if (buf[0] === 0xff && buf[1] === 0xd8 && buf[2] === 0xff) return "image/jpeg";
    if (buf[0] === 0x89 && buf[1] === 0x50 && buf[2] === 0x4e && buf[3] === 0x47) return "image/png";
    if (buf[0] === 0x47 && buf[1] === 0x49 && buf[2] === 0x46) return "image/gif";
    if (
      buf[0] === 0x52 &&
      buf[1] === 0x49 &&
      buf[2] === 0x46 &&
      buf[3] === 0x46
    ) {
      return "image/webp";
    }
  } catch (_err) {
    return "";
  }
  return "";
};

const heicToJpeg = async (file) => {
  try {
    if (typeof createImageBitmap !== "function") return file;
    const bitmap = await createImageBitmap(file);
    const canvas = document.createElement("canvas");
    canvas.width = bitmap.width;
    canvas.height = bitmap.height;
    const ctx = canvas.getContext("2d");
    ctx.drawImage(bitmap, 0, 0);
    bitmap.close?.();
    const blob = await new Promise((resolve) => canvas.toBlob(resolve, "image/jpeg", 0.85));
    if (!blob) return file;
    const base = String(file.name || "photo").replace(/\.(heic|heif)$/i, "");
    return new File([blob], `${base || "photo"}.jpg`, {
      type: "image/jpeg",
      lastModified: file.lastModified || Date.now(),
    });
  } catch (_err) {
    return file;
  }
};

const uploadNameFor = (file, fallback = "photo.jpg") => {
  const name = file?.name || fallback;
  if (IMAGE_EXT.test(name) && !/\.(heic|heif)$/i.test(name)) return name;
  const ext = String(file?.type || "").split("/")[1] || "jpg";
  const mapped = ext === "jpeg" ? "jpg" : ext;
  const base = String(name).replace(/\.[^.]+$/, "") || "photo";
  return `${base}.${mapped}`;
};

const prepareOutgoingFile = async (file) => {
  if (!file) return file;
  let mime = isEmptyMime(file.type) ? guessMimeFromName(file.name) : file.type;
  const sniffed = await sniffImageMime(file);
  if (sniffed) mime = sniffed;
  const isHeic = /heic|heif/i.test(mime) || /\.(heic|heif)$/i.test(file.name || "");
  if (isHeic) return heicToJpeg(file);
  if (mime && mime !== file.type) {
    return new File([file], uploadNameFor({ name: file.name, type: mime }), {
      type: mime,
      lastModified: file.lastModified || Date.now(),
    });
  }
  return file;
};


import useQuickMessages from "../../hooks/useQuickMessages";
import useFiles from "../../hooks/useFiles";
import logger from "../../utils/logger";
import AttachmentPreview from "../AttachmentPreview";
import QuickMessageDialog from "../QuickMessageDialog";

/** 0293 B: caché firma interna — evita GET por cada envío; TTL sesión (tab). */
const internalSignatureCache = { value: null, expiresAt: 0 };
const INTERNAL_SIGNATURE_CACHE_TTL_MS = 5 * 60 * 1000;

function renderQuickMessageText(message, ticket) {
  const contact = ticket?.contact || {};
  const name = contact.name || "";
  const firstName = name.trim().split(/\s+/)[0] || name;
  const number = contact.number || "";
  const email = contact.email || "";

  return String(message || "")
    .replace(/\{\{\s*name\s*\}\}/gi, name)
    .replace(/\{\{\s*firstName\s*\}\}/gi, firstName)
    .replace(/\{\{\s*number\s*\}\}/gi, number)
    .replace(/\{\{\s*email\s*\}\}/gi, email)
    .replace(/\{name\}/gi, name)
    .replace(/\{firstName\}/gi, firstName)
    .replace(/\{number\}/gi, number)
    .replace(/\{email\}/gi, email);
}

async function fetchInternalSignatureEnabled(apiInstance) {
  const now = Date.now();
  if (internalSignatureCache.expiresAt > now && internalSignatureCache.value !== null) {
    return internalSignatureCache.value;
  }
  try {
    const { data: setting } = await apiInstance.get(`/settings/internalSignature`);
    const enabled = setting?.value === "enabled";
    internalSignatureCache.value = enabled;
    internalSignatureCache.expiresAt = now + INTERNAL_SIGNATURE_CACHE_TTL_MS;
    return enabled;
  } catch (_err) {
    internalSignatureCache.value = false;
    internalSignatureCache.expiresAt = now + INTERNAL_SIGNATURE_CACHE_TTL_MS;
    return false;
  }
}

// ✅ CORRECCIÓN: Inicialización segura de MicRecorder
const Mp3Recorder = new MicRecorder({ bitRate: 128 });

// ✅ VALIDACIÓN: Verificar que MicRecorder se inicializó correctamente
if (!Mp3Recorder) {
  console.warn("⚠️ [WARNING] MicRecorder no se inicializó correctamente");
}

const useStyles = makeStyles((theme) => ({
  mainWrapper: {
    backgroundColor: "transparent",
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    flexShrink: 0,
    padding: "6px 10px 10px",
    marginTop: 0,
    position: "relative",
    borderTop: "none",
    [theme.breakpoints.down("sm")]: {
      marginTop: 0,
      padding: "4px 6px calc(6px + env(safe-area-inset-bottom, 0px)) 6px",
      position: "sticky",
      bottom: 0,
      zIndex: 20,
      backgroundColor: CHAT.composerBg(theme),
    },
  },

  /** Vista móvil (sm-): una sola fila, campo de texto con flex 1 */
  newMessageBoxCompact: {
    padding: "4px 4px",
    flexWrap: "nowrap",
    alignItems: "flex-end",
    gap: 4,
  },
  messageInputWrapperGrow: {
    flex: 1,
    minWidth: 0,
    marginRight: 4,
  },
  mobileComposerFab: {
    flexShrink: 0,
    backgroundColor: theme.mode === 'dark' ? '#3b82f6' : '#e3f2fd',
    borderRadius: '50%',
    '&:hover': {
      backgroundColor: theme.mode === 'dark' ? '#2563eb' : '#bbdefb',
    },
  },
  newMessageBox: {
    backgroundColor: CHAT.composerBar(theme),
    width: "100%",
    display: "flex",
    padding: "6px 8px",
    alignItems: "center",
    gap: 6,
    borderRadius: 16,
    boxShadow: "0 1px 2px rgba(11,20,26,.08)",
    border: BORDERS.base(theme),
    transition: TRANSITION,
    "&:focus-within": {
      boxShadow: `0 0 0 1px ${theme.palette.primary.main}, ${SHADOWS.lift(theme)}`,
      borderColor: theme.palette.primary.main,
    },
  },

  messageInputWrapper: {
    padding: 0,
    marginRight: 8,
    backgroundColor: "transparent",
    display: "flex",
    borderRadius: 0,
    flex: 1,
    position: "relative", // ✅ Para el posicionamiento del dropdown
    [theme.breakpoints.down("sm")]: {
      marginRight: 4,
    },
  },

  messageInput: {
    paddingLeft: 10,
    flex: 1,
    border: "none",
    backgroundColor: "transparent",
    fontSize: 14,
    lineHeight: 1.4,
    color: theme.mode === 'dark' ? '#f9fafb' : '#1f2937', // ✅ USA TEMA - Color del texto
    "&::placeholder": {
      color: theme.mode === 'dark' ? '#9ca3af' : '#6b7280', // ✅ USA TEMA - Color del placeholder
    },
    [theme.breakpoints.down("sm")]: {
      paddingLeft: 6,
      fontSize: 15,
      lineHeight: 1.35,
    },
  },

  sendMessageIcons: {
    color: theme.mode === 'dark' ? '#9ca3af' : '#54656f',
  },

  sendActionButton: {
    backgroundColor: theme.palette.primary.main,
    color: "#fff",
    width: 36,
    height: 36,
    minWidth: 36,
    padding: "0 !important",
    marginLeft: 4,
    flexShrink: 0,
    "&:hover": {
      backgroundColor: theme.palette.primary.dark,
    },
    "&.Mui-disabled": {
      opacity: 0.45,
      backgroundColor: theme.palette.primary.main,
      color: "#fff",
    },
    "& svg": {
      fontSize: 20,
      color: "#fff",
    },
  },
  composerActions: {
    display: "flex",
    alignItems: "center",
    gap: 4,
    padding: "0 4px 6px",
    flexWrap: "wrap",
  },
  composerActionBtn: {
    textTransform: "none",
    fontWeight: 600,
    fontSize: 13,
    color: theme.palette.primary.main,
    padding: "2px 8px",
    minWidth: 0,
    borderRadius: 8,
  },
  composerActionBtnActive: {
    backgroundColor: theme.mode === "dark" ? "rgba(79,70,245,0.16)" : "#eef0ff",
  },
  composerIconBtn: {
    padding: 6,
    width: 32,
    height: 32,
    minWidth: 32,
    margin: "0 1px",
    flexShrink: 0,
    color: theme.mode === "dark" ? "#9ca3af" : "#667781",
    "&:hover": {
      backgroundColor: theme.mode === "dark" ? "rgba(255,255,255,0.06)" : "#f1f3f9",
    },
    "& svg": {
      fontSize: 22,
    },
  },

  ForwardMessageIcons: {
    color: grey[700],
    transform: 'scaleX(-1)'
  },

  uploadInput: {
    display: "none",
  },

  viewMediaInputWrapper: {
    display: "flex",
    flexDirection: "column",
    padding: "8px 12px",
    position: "relative",
    alignItems: "stretch",
    backgroundColor: CHAT.composerBg(theme),
    borderTop: BORDERS.base(theme),
    [theme.breakpoints.down("sm")]: {
      padding: "8px 8px calc(8px + env(safe-area-inset-bottom)) 8px",
      position: "sticky",
      bottom: 0,
      zIndex: 20,
    },
  },
  mediaCompose: {
    display: "flex",
    flexDirection: "column",
    gap: 8,
    width: "100%",
  },
  mediaComposeRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
    width: "100%",
    minWidth: 0,
  },
  mediaCaptionWrap: {
    flex: 1,
    minWidth: 0,
  },
  mediaThumbs: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
    overflowX: "auto",
    overflowY: "hidden",
    WebkitOverflowScrolling: "touch",
    ...(theme.hiddenScrollbar || {
      scrollbarWidth: "none",
      msOverflowStyle: "none",
      "&::-webkit-scrollbar": { display: "none" },
    }),
  },
  mediaThumb: {
    position: "relative",
    width: 56,
    height: 56,
    borderRadius: 10,
    overflow: "hidden",
    flexShrink: 0,
    backgroundColor: theme.mode === "dark" ? "#374151" : "#fff",
    border: `1px solid ${theme.mode === "dark" ? "#4B5563" : "#ddd"}`,
  },
  mediaAddMore: {
    width: 56,
    height: 56,
    borderRadius: 10,
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    backgroundColor: theme.mode === "dark" ? "#374151" : "#f0f0f0",
    border: `2px dashed ${theme.mode === "dark" ? "#6B7280" : "#ccc"}`,
    color: theme.mode === "dark" ? "#9ca3af" : "#666",
    fontSize: 22,
    fontWeight: 700,
  },
  mediaComposeActions: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: 6,
    flexShrink: 0,
  },

  emojiBox: {
    position: "absolute",
    bottom: 63,
    width: 40,
    borderTop: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#e8e8e8'}`, // ✅ USA TEMA
    [theme.breakpoints.down("sm")]: {
      left: 8,
      bottom: 56,
      transform: "scale(0.9)",
      transformOrigin: "bottom left",
    },
  },

  circleLoading: {
    color: theme.palette.primary.main,
    opacity: "70%",
    position: "absolute",
    top: "20%",
    left: "50%",
    marginLeft: -12,
  },

  audioLoading: {
    color: theme.palette.primary.main,
    opacity: "70%",
  },

  // ✅ CORRECTO: Estilos para el dropdown de respuestas rápidas - UX VISIBLE Y PROFESIONAL
  quickMessagesDropdown: {
    backgroundColor: theme.palette.background.paper,
    border: BORDERS.base(theme),
    borderRadius: 14,
    boxShadow: SHADOWS.lift(theme),
    zIndex: 9999,
    maxHeight: "250px",
    overflow: "auto",
    minHeight: "40px",
    padding: "8px 0",
    // ✅ FORZAR VISIBILIDAD DEL CONTENIDO
    "& .MuiAutocomplete-listbox": {
      padding: "0",
      maxHeight: "none",
        "& .MuiAutocomplete-option": {
          padding: "12px 16px",
          fontSize: "14px",
          minHeight: "44px",
          lineHeight: "1.4",
          borderBottom: `1px solid ${theme.mode === 'dark' ? '#374151' : '#f0f0f0'}`, // ✅ USA TEMA
          display: "flex",
          alignItems: "center",
          cursor: "pointer",
          color: theme.mode === 'dark' ? '#f9fafb' : '#1f2937', // ✅ USA TEMA - Color del texto
          "&:last-child": {
            borderBottom: "none"
          },
          "&:hover": {
            backgroundColor: theme.mode === 'dark' ? '#374151' : '#f8f9fa', // ✅ USA TEMA
          },
          "&.Mui-focused": {
            backgroundColor: theme.mode === 'dark' ? '#3b82f6' : '#e3f2fd', // ✅ USA TEMA
          },
          "&.Mui-selected": {
            backgroundColor: theme.mode === 'dark' ? '#3b82f6' : '#e3f2fd', // ✅ USA TEMA
            fontWeight: "500"
          }
        }
    },
    // ✅ ESTILOS ADICIONALES PARA MEJOR VISIBILIDAD
    "& .MuiAutocomplete-paper": {
      backgroundColor: theme.mode === 'dark' ? '#1f2937' : '#ffffff', // ✅ USA TEMA
      boxShadow: theme.mode === 'dark' ? '0 4px 12px rgba(0,0,0,0.5)' : '0 4px 12px rgba(0,0,0,0.15)', // ✅ USA TEMA
      borderRadius: "8px",
      border: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#e0e0e0'}` // ✅ USA TEMA
    }
  },

  recorderWrapper: {
    display: "flex",
    alignItems: "center",
    alignContent: "middle",
  },

  cancelAudioIcon: {
    color: "red",
  },

  sendAudioIcon: {
    color: "green",
  },

  replyginMsgWrapper: {
    display: "flex",
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
    paddingTop: 4,
    paddingLeft: 8,
    paddingRight: 8,
    paddingBottom: 6,
    [theme.breakpoints.down("sm")]: {
      paddingLeft: 8,
      paddingRight: 8,
      paddingTop: 4,
    },
  },

  quickMessagesPanel: {
    position: "absolute",
    left: 0,
    right: 0,
    bottom: "calc(100% + 8px)",
    zIndex: 10000,
    maxHeight: 260,
    overflowY: "auto",
    backgroundColor: theme.mode === 'dark' ? '#1f2937' : '#ffffff',
    border: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#e0e0e0'}`,
    borderRadius: 8,
    boxShadow: theme.mode === 'dark' ? '0 8px 24px rgba(0,0,0,0.55)' : '0 8px 24px rgba(0,0,0,0.18)',
    padding: "6px 0",
  },

  quickMessagesPanelAdd: {
    width: "100%",
    border: 0,
    background: "transparent",
    display: "flex",
    alignItems: "center",
    gap: 8,
    minHeight: 42,
    padding: "8px 12px",
    cursor: "pointer",
    textAlign: "left",
    color: theme.palette.primary.main,
    fontSize: 14,
    fontWeight: 600,
    borderBottom: `1px solid ${theme.mode === 'dark' ? '#374151' : '#f0f0f0'}`,
    "&:hover": {
      backgroundColor: theme.mode === 'dark' ? '#374151' : '#f8f9fa',
    },
    "& svg": {
      fontSize: 18,
    },
  },

  quickMessagesPanelItem: {
    width: "100%",
    border: 0,
    background: "transparent",
    display: "flex",
    alignItems: "center",
    gap: 8,
    minHeight: 44,
    padding: "9px 12px",
    cursor: "pointer",
    textAlign: "left",
    color: theme.mode === 'dark' ? '#f9fafb' : '#1f2937',
    borderBottom: `1px solid ${theme.mode === 'dark' ? '#374151' : '#f0f0f0'}`,
    "&:hover": {
      backgroundColor: theme.mode === 'dark' ? '#374151' : '#f8f9fa',
    },
    "&:last-child": {
      borderBottom: 0,
    },
  },

  quickMessagesPanelShortcut: {
    flexShrink: 0,
    maxWidth: 120,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    color: theme.mode === 'dark' ? '#60a5fa' : '#1976d2',
    backgroundColor: theme.mode === 'dark' ? '#1e3a8a' : '#e3f2fd',
    borderRadius: 4,
    padding: "2px 6px",
    fontSize: 12,
    fontWeight: 600,
  },

  quickMessagesPanelMessage: {
    flex: 1,
    minWidth: 0,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    fontSize: 14,
  },

  quickMessagesPanelEmpty: {
    padding: "12px 14px",
    color: theme.mode === 'dark' ? '#9ca3af' : '#666',
    fontSize: 14,
    textAlign: "center",
  },

  replyginMsgContainer: {
    flex: 1,
    marginRight: 5,
    overflowY: "hidden",
    backgroundColor: theme.mode === 'dark' ? '#111827' : '#f0f2f5',
    borderRadius: 12,
    display: "flex",
    position: "relative",
    border: BORDERS.base(theme),
  },

  replyginMsgBody: {
    padding: 10,
    height: "auto",
    display: "block",
    whiteSpace: "pre-wrap",
    overflow: "hidden",
  },

  replyginContactMsgSideColor: {
    flex: "none",
    width: "4px",
    backgroundColor: "#35cd96",
  },

  replyginSelfMsgSideColor: {
    flex: "none",
    width: "4px",
    backgroundColor: "#6bcbef",
  },

  messageContactName: {
    display: "flex",
    color: "#6bcbef",
    fontWeight: 500,
  },
}));

const EmojiOptions = (props) => {
  const { disabled, showEmoji, setShowEmoji, handleAddEmoji, hideButton } = props;
  const classes = useStyles();
  return (
    <>
      {!hideButton && (
        <IconButton
          aria-label="emojiPicker"
          component="span"
          disabled={disabled}
          className={classes.composerIconBtn}
          onClick={(e) => setShowEmoji((prevState) => !prevState)}
        >
          <MoodIcon />
        </IconButton>
      )}
      {showEmoji ? (
        <div className={classes.emojiBox}>
          <Picker
            perLine={16}
            showPreview={false}
            showSkinTones={false}
            onSelect={handleAddEmoji}
          />
        </div>
      ) : null}
    </>
  );
};

const SignSwitch = (props) => {
  const { setSignMessage, signMessage } = props;
  const classes = useStyles();
  return (
    <Button
      className={clsx(classes.composerActionBtn, signMessage && classes.composerActionBtnActive)}
      onClick={() => setSignMessage(!signMessage)}
      size="small"
    >
      Firmar
    </Button>
  );
};

const FileInput = (props) => {
  const { handleChangeMedias, disableOption, hideTriggerButton, labeled } = props;
  const classes = useStyles();
  const theme = useTheme();
  
  // ✅ ESTADO PARA EL MENÚ DESPLEGABLE
  const [anchorEl, setAnchorEl] = useState(null);

  // ✅ FUNCIONES PARA MANEJAR EL MENÚ
  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  // ✅ FUNCIONES PARA CADA OPCIÓN DEL MENÚ
  const handleDocumentClick = () => {
    handleMenuClose();
    // Crear input temporal para documentos
    const input = document.createElement('input');
    input.type = 'file';
    input.multiple = true;
    input.accept = '.pdf,.doc,.docx,.xls,.xlsx,.txt,.ppt,.pptx';
    input.onchange = (e) => handleChangeMedias(e);
    input.click();
  };

  const handlePhotoVideoClick = () => {
    handleMenuClose();
    // Crear input temporal para fotos y videos
    const input = document.createElement('input');
    input.type = 'file';
    input.multiple = true;
    input.accept = 'image/*,video/*';
    input.onchange = (e) => handleChangeMedias(e);
    input.click();
  };

  const handleAudioClick = () => {
    handleMenuClose();
    // Crear input temporal para audio
    const input = document.createElement('input');
    input.type = 'file';
    input.multiple = true;
    input.accept = 'audio/*';
    input.onchange = (e) => handleChangeMedias(e);
    input.click();
  };

  const handleContactClick = () => {
    handleMenuClose();
    // TODO: Implementar funcionalidad de contactos
    console.log('Contactos - Por implementar');
  };

  return (
    <>
      {/* ✅ INPUT OCULTO ORIGINAL */}
      <input
        multiple
        type="file"
        id="upload-button"
        disabled={disableOption()}
        className={classes.uploadInput}
        onChange={handleChangeMedias}
        accept="image/*,video/*,audio/*,.pdf,.doc,.docx,.xls,.xlsx,.txt"
      />
      
      {!hideTriggerButton && (
        <>
      {labeled ? (
        <Button
          className={classes.composerActionBtn}
          size="small"
          disabled={disableOption()}
          onClick={handleMenuOpen}
        >
          Adjuntar
        </Button>
      ) : (
      <IconButton
        aria-label="upload"
        component="span"
        disabled={disableOption()}
        title="Adjuntar archivos - Estilo WhatsApp Web"
        className={classes.composerIconBtn}
        onClick={handleMenuOpen}
      >
        <AddIcon />
      </IconButton>
      )}

      {/* ✅ MENÚ DESPLEGABLE ESTILO WHATSAPP WEB */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        PaperProps={{
          style: {
            backgroundColor: theme.palette.background.paper,
            borderRadius: '12px',
            boxShadow: theme.mode === 'dark' ? '0 4px 20px rgba(0,0,0,0.5)' : '0 4px 20px rgba(0,0,0,0.15)',
            minWidth: '200px',
            padding: '8px 0',
            border: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#e0e0e0'}`,
          }
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        {/* ✅ DOCUMENTOS */}
        <MenuItem 
          onClick={handleDocumentClick} 
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = theme.mode === 'dark' ? '#374151' : '#f5f5f5';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = theme.palette.background.paper;
          }}
          style={{ 
            padding: '12px 16px',
            backgroundColor: theme.palette.background.paper,
          }}
        >
          <ListItemIcon style={{ minWidth: '40px' }}>
            <DescriptionIcon style={{ color: '#9c27b0', fontSize: '24px' }} />
          </ListItemIcon>
          <ListItemText 
            primary="Documentos" 
            primaryTypographyProps={{
              style: { 
                fontSize: '14px', 
                fontWeight: '500',
                color: theme.palette.text.primary,
              }
            }}
          />
        </MenuItem>

        {/* ✅ FOTOS Y VIDEOS */}
        <MenuItem 
          onClick={handlePhotoVideoClick} 
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = theme.mode === 'dark' ? '#374151' : '#f5f5f5';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = theme.palette.background.paper;
          }}
          style={{ 
            padding: '12px 16px',
            backgroundColor: theme.palette.background.paper,
          }}
        >
          <ListItemIcon style={{ minWidth: '40px' }}>
            <PhotoCameraIcon style={{ color: '#2196f3', fontSize: '24px' }} />
          </ListItemIcon>
          <ListItemText 
            primary="Fotos y Videos" 
            primaryTypographyProps={{
              style: { 
                fontSize: '14px', 
                fontWeight: '500',
                color: theme.palette.text.primary,
              }
            }}
          />
        </MenuItem>

        {/* ✅ AUDIO */}
        <MenuItem 
          onClick={handleAudioClick} 
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = theme.mode === 'dark' ? '#374151' : '#f5f5f5';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = theme.palette.background.paper;
          }}
          style={{ 
            padding: '12px 16px',
            backgroundColor: theme.palette.background.paper,
          }}
        >
          <ListItemIcon style={{ minWidth: '40px' }}>
            <MicIcon style={{ color: '#ff9800', fontSize: '24px' }} />
          </ListItemIcon>
          <ListItemText 
            primary="Audio" 
            primaryTypographyProps={{
              style: { 
                fontSize: '14px', 
                fontWeight: '500',
                color: theme.palette.text.primary,
              }
            }}
          />
        </MenuItem>

        {/* ✅ CONTACTOS */}
        <MenuItem 
          onClick={handleContactClick} 
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = theme.mode === 'dark' ? '#374151' : '#f5f5f5';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = theme.palette.background.paper;
          }}
          style={{ 
            padding: '12px 16px',
            backgroundColor: theme.palette.background.paper,
          }}
        >
          <ListItemIcon style={{ minWidth: '40px' }}>
            <ContactPhoneIcon style={{ color: '#4caf50', fontSize: '24px' }} />
          </ListItemIcon>
          <ListItemText 
            primary="Contactos" 
            primaryTypographyProps={{
              style: { 
                fontSize: '14px', 
                fontWeight: '500',
                color: theme.palette.text.primary,
              }
            }}
          />
        </MenuItem>
      </Menu>
        </>
      )}
    </>
  );
};

const ActionButtons = (props) => {
  const {
    inputMessage,
    loading,
    sendingText,
    recording,
    ticketStatus,
    handleSendMessage,
    handleCancelAudio,
    handleUploadAudio,
    handleStartRecording,
    handleOpenModalForward,
    showSelectMessageCheckbox
  } = props;
  const classes = useStyles();
  
  // ✅ FUNCIÓN PARA CANCELAR SELECCIÓN DE MENSAJES
  const handleCancelSelection = () => {
    const { setShowSelectMessageCheckbox, setSelectedMessages } = props;
    setShowSelectMessageCheckbox(false);
    setSelectedMessages([]);
  };
  
  if (showSelectMessageCheckbox) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        {/* ✅ BOTÓN CANCELAR */}
        <IconButton
          aria-label="cancelSelection"
          component="span"
          onClick={handleCancelSelection}
          disabled={loading}
          style={{ color: '#f44336' }}
          title="Cancelar selección"
        >
          <HighlightOffIcon className={classes.sendMessageIcons} />
        </IconButton>
        <IconButton
          aria-label="forwardMessage"
          component="span"
          onClick={handleOpenModalForward}
          disabled={loading}
        >
          <Reply className={classes.ForwardMessageIcons} />
        </IconButton>
      </div>
    );
  } else if (inputMessage || sendingText) {
    return (
      <IconButton
        aria-label="sendMessage"
        component="span"
        onClick={handleSendMessage}
        disabled={loading}
        className={classes.sendActionButton}
      >
        {sendingText ? (
          <CircularProgress size={22} style={{ color: "#2563eb" }} />
        ) : (
          <SendIcon />
        )}
      </IconButton>
    );
  } else if (recording) {
    return (
      <div className={classes.recorderWrapper}>
        <IconButton
          aria-label="cancelRecording"
          component="span"
          fontSize="large"
          disabled={loading}
          onClick={handleCancelAudio}
        >
          <HighlightOffIcon className={classes.cancelAudioIcon} />
        </IconButton>
        {loading ? (
          <div>
            <CircularProgress className={classes.audioLoading} />
          </div>
        ) : (
          <RecordingTimer />
        )}

        <IconButton
          aria-label="sendRecordedAudio"
          component="span"
          onClick={handleUploadAudio}
          disabled={loading}
        >
          <CheckCircleOutlineIcon className={classes.sendAudioIcon} />
        </IconButton>
      </div>
    );
  } else {
    return (
      <IconButton
        aria-label="showRecorder"
        component="span"
        disabled={loading || ticketStatus !== "open"}
        onClick={handleStartRecording}
        className={classes.sendActionButton}
      >
        <MicIcon />
      </IconButton>
    );
  }
};

const CustomInput = (props) => {
  const {
    loading,
    inputRef,
    ticketStatus,
    inputMessage,
    setInputMessage,
    handleSendMessage,
    handleInputPaste,
    disableOption,
    handleQuickAnswersClick,
    options,
    popupOpen,
    setPopupOpen,
    onAddQuickMessage,
    inputWrapperClassName
  } = props;
  const classes = useStyles();
  const theme = useTheme(); // ✅ NUEVO: Para acceder al tema en estilos inline

  const selectQuickMessageOption = (option) => {
    if (!isObject(option) || !has(option, "value")) return;

    setPopupOpen(false);
    setInputMessage(`/${String(option.shortcode || "").trim()}`);
    setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.scrollTop = inputRef.current.scrollHeight;
        inputRef.current.focus();
      }
    }, 200);
  };

  const getBestQuickMessageOption = () => {
    if (!Array.isArray(options) || options.length === 0) return null;
    const typedShortcut = String(inputMessage || "").replace(/^\/+/, "").trim().toLowerCase();
    return options.find((option) =>
      String(option?.shortcode || "").trim().toLowerCase() === typedShortcut
    ) || options[0];
  };

  // ✅ CORREGIDO: Manejar navegación con flechas ↑↓
  const onKeyDown = (e) => {
    // ✅ 0293 B: Enter = enviar, Shift+Enter = nueva línea (multiline); IME sin interferir
    if (e.key === "Enter") {
      if (e.nativeEvent?.isComposing) return;
      if (loading) return;
      if (e.shiftKey) return;
      if (popupOpen) {
        const option = getBestQuickMessageOption();
        if (option) {
          e.preventDefault();
          e.stopPropagation();
          selectQuickMessageOption(option);
        }
        return;
      }
      e.preventDefault();
      e.stopPropagation();
      handleSendMessage();
      return;
    }

    // ✅ PERMITIR NAVEGACIÓN CON FLECHAS - No prevenir el comportamiento por defecto
    if (e.key === "ArrowUp" || e.key === "ArrowDown") {
      // ✅ Solo prevenir si el popup está abierto (para respuestas rápidas)
      if (popupOpen) {
        // ✅ Dejar que el Autocomplete maneje la navegación en el popup
        return;
      }
      // ✅ Si no hay popup, permitir navegación normal en el texto
      e.stopPropagation();
      return;
    }
    
    // ✅ Permitir Ctrl+↑↓ para navegar por párrafos
    if ((e.key === "ArrowUp" || e.key === "ArrowDown") && e.ctrlKey) {
      e.stopPropagation();
      return;
    }
    
    // ✅ Permitir Home/End para navegar al inicio/final de línea
    if (e.key === "Home" || e.key === "End") {
      e.stopPropagation();
      return;
    }
    
    // ✅ Permitir Ctrl+Home/End para navegar al inicio/final del texto
    if ((e.key === "Home" || e.key === "End") && e.ctrlKey) {
      e.stopPropagation();
      return;
    }
    
    // ✅ Permitir Page Up/Page Down para navegación rápida
    if (e.key === "PageUp" || e.key === "PageDown") {
      e.stopPropagation();
      return;
    }
    
    // ✅ Permitir Ctrl+A para seleccionar todo
    if (e.key === "a" && e.ctrlKey) {
      e.stopPropagation();
      return;
    }
  };

  const onPaste = (e) => {
    if (ticketStatus === "open") {
      handleInputPaste(e);
    }
  };

  const renderPlaceholder = () => {
    if (ticketStatus === "open") {
      return i18n.t("messagesInput.placeholderOpen");
    }
    return i18n.t("messagesInput.placeholderClosed");
  };


  const setInputRef = (input) => {
    if (input) {
      input.focus();
      inputRef.current = input;
      
      // ✅ CORREGIDO: Agregar manejador de teclado directamente al elemento
      const handleDirectKeyDown = (e) => {
        // ✅ Solo manejar si no hay popup abierto
        if (!popupOpen) {
          // ✅ Permitir navegación con flechas
          if (e.key === "ArrowUp" || e.key === "ArrowDown") {
            // ✅ No prevenir el comportamiento por defecto
            return;
          }
          
          // ✅ Permitir otras teclas de navegación
          if (e.key === "Home" || e.key === "End" || 
              e.key === "PageUp" || e.key === "PageDown" ||
              ((e.key === "ArrowUp" || e.key === "ArrowDown") && e.ctrlKey) ||
              ((e.key === "Home" || e.key === "End") && e.ctrlKey)) {
            return;
          }
        }
      };
      
      // ✅ Agregar el manejador directamente al elemento
      input.addEventListener('keydown', handleDirectKeyDown);
      
      // ✅ Limpiar el manejador cuando el componente se desmonte
      return () => {
        input.removeEventListener('keydown', handleDirectKeyDown);
      };
    }
  };

  return (
    <div className={clsx(classes.messageInputWrapper, inputWrapperClassName)}>
      {popupOpen && (
        <div className={classes.quickMessagesPanel}>
          <button
            type="button"
            className={classes.quickMessagesPanelAdd}
            onMouseDown={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setPopupOpen(false);
              if (typeof onAddQuickMessage === "function") onAddQuickMessage();
            }}
          >
            <AddIcon fontSize="small" />
            Añadir /
          </button>
          {options.length > 0 ? (
            options.map((option) => (
              <button
                key={`${option.shortcode}-${option.value}`}
                type="button"
                className={classes.quickMessagesPanelItem}
                onMouseDown={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  selectQuickMessageOption(option);
                }}
              >
                {option.mediaPath && option.mediaPath !== "null" && (
                  <span
                    onMouseDown={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                    }}
                  >
                    <AttachmentPreview
                      size="compact"
                      mediaPath={option.mediaPath}
                      mediaName={option.mediaName}
                    />
                  </span>
                )}
                <span className={classes.quickMessagesPanelShortcut}>
                  /{option.shortcode}
                </span>
                <span className={classes.quickMessagesPanelMessage}>
                  {option.message}
                </span>
              </button>
            ))
          ) : (
            <div className={classes.quickMessagesPanelEmpty}>
              No hay respuestas rápidas
            </div>
          )}
        </div>
      )}
      <Autocomplete
        freeSolo
        open={false}
        id="quick-messages-autocomplete"
        value={inputMessage}
        options={options}
        closeIcon={null}
        disablePortal={false}
        disableClearable={true}
        disableCloseOnSelect={true}
        // ✅ CORRECTO: Configuración de posicionamiento del dropdown - UX DINÁMICO Y VISIBLE
        PopperComponent={(props) => {
          // ✅ Filtrar props que no deben ir al DOM
          const { anchorEl, open, ...domProps } = props;
          
          // ✅ Buscar el input de manera más específica y precisa
          const inputElement = document.querySelector('.messageInputWrapper input') || 
                              document.querySelector('[placeholder*="Escribe un mensaje"]') ||
                              document.querySelector('[placeholder*="Type a message"]') ||
                              document.querySelector('input[multiline]');
          const inputRect = inputElement ? inputElement.getBoundingClientRect() : null;
          
          // ✅ POSICIONAMIENTO DINÁMICO: Justo encima del campo "Escribir"
          // ✅ Obtener el tema actual desde el contexto
          const currentTheme = window.document.documentElement.classList.contains('dark-mode') ? 'dark' : 'light';
          
          let dropdownStyle = {
            ...domProps.style,
            zIndex: 9999,
            position: 'fixed',
            maxHeight: '250px',
            overflow: 'auto',
            backgroundColor: currentTheme === 'dark' ? '#1f2937' : '#ffffff',
            border: `1px solid ${currentTheme === 'dark' ? '#4B5563' : '#e0e0e0'}`,
            borderRadius: '8px',
            boxShadow: currentTheme === 'dark' ? '0 4px 12px rgba(0,0,0,0.5)' : '0 4px 12px rgba(0,0,0,0.15)',
            // ✅ FORZAR VISIBILIDAD DEL CONTENIDO
            minHeight: '40px',
            padding: '8px 0'
          };
          
          if (inputRect) {
            // ✅ CALCULAR ALTURA DEL DROPDOWN DINÁMICAMENTE BASADO EN OPCIONES
            const optionsCount = options ? options.length : 0;
            const dropdownHeight = Math.min(250, Math.max(40, (optionsCount * 44) + 16)); // 44px por opción + padding
            
            // ✅ POSICIONAR ARRIBA DEL INPUT CON ALTURA DINÁMICA
            dropdownStyle.top = `${inputRect.top - dropdownHeight - 8}px`;
            dropdownStyle.left = `${inputRect.left}px`;
            dropdownStyle.width = `${Math.max(inputRect.width, 350)}px`;
            dropdownStyle.bottom = 'auto';
            dropdownStyle.right = 'auto';
            dropdownStyle.height = `${dropdownHeight}px`;
            
            // ✅ AJUSTAR SI SE SALE POR ARRIBA DE LA PANTALLA
            if (inputRect.top - dropdownHeight - 8 < 0) {
              // ✅ SI NO CABE ARRIBA, MOSTRAR DEBAJO PERO CON SCROLL LIMITADO
              dropdownStyle.top = `${inputRect.bottom + 8}px`;
              dropdownStyle.height = `${Math.min(200, window.innerHeight - inputRect.bottom - 16)}px`;
              dropdownStyle.maxHeight = `${Math.min(200, window.innerHeight - inputRect.bottom - 16)}px`;
            }
            
            // ✅ AJUSTAR SI SE SALE POR LA DERECHA DE LA PANTALLA
            if (inputRect.left + inputRect.width > window.innerWidth) {
              dropdownStyle.left = `${window.innerWidth - Math.max(inputRect.width, 350) - 8}px`;
            }
            
            // ✅ AJUSTAR SI SE SALE POR LA IZQUIERDA DE LA PANTALLA
            if (inputRect.left < 0) {
              dropdownStyle.left = '8px';
            }
          } else {
            // ✅ FALLBACK: Posición por defecto cerca del bottom
            dropdownStyle.bottom = '80px';
            dropdownStyle.left = '50%';
            dropdownStyle.transform = 'translateX(-50%)';
            dropdownStyle.width = '350px';
            dropdownStyle.top = 'auto';
            dropdownStyle.right = 'auto';
          }
          
          return (
            <div
              {...domProps}
              className={classes.quickMessagesDropdown}
              style={dropdownStyle}
            />
          );
        }}
        getOptionLabel={(option) => {
          if (isObject(option)) {
            return option.label;
          } else {
            return option;
          }
        }}
        // ✅ RENDERIZADO PERSONALIZADO DE OPCIONES PARA MEJOR UX
        renderOption={(option) => {
          if (isObject(option)) {
            return (
              <div style={{ 
                padding: "12px 16px",
                fontSize: "14px",
                minHeight: "44px",
                lineHeight: "1.4",
                borderBottom: `1px solid ${theme.mode === 'dark' ? '#374151' : '#f0f0f0'}`, // ✅ USA TEMA
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                backgroundColor: "transparent",
                transition: "background-color 0.2s ease",
                "&:hover": {
                  backgroundColor: theme.mode === 'dark' ? '#374151' : '#f8f9fa', // ✅ USA TEMA
                }
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = theme.mode === 'dark' ? '#374151' : '#f8f9fa'; // ✅ USA TEMA
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = 'transparent';
              }}
              onMouseDown={(e) => {
                e.preventDefault();
                e.stopPropagation();
                selectQuickMessageOption(option);
              }}
              >
                <div style={{ 
                  display: "flex", 
                  alignItems: "center", 
                  width: "100%",
                  gap: "8px"
                }}>
                  {option.mediaPath && option.mediaPath !== "null" && (
                    <span
                      onMouseDown={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                      }}
                    >
                      <AttachmentPreview
                        size="compact"
                        mediaPath={option.mediaPath}
                        mediaName={option.mediaName}
                      />
                    </span>
                  )}
                  <span style={{ 
                    color: theme.mode === 'dark' ? '#60a5fa' : "#2196f3", // ✅ USA TEMA
                    fontWeight: "500",
                    fontSize: "12px",
                    backgroundColor: theme.mode === 'dark' ? '#1e3a8a' : "#e3f2fd", // ✅ USA TEMA
                    padding: "2px 6px",
                    borderRadius: "4px"
                  }}>
                    {option.shortcode}
                  </span>
                  <span style={{ 
                    color: theme.mode === 'dark' ? '#f9fafb' : "#333", // ✅ USA TEMA
                    flex: 1,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap"
                  }}>
                    {option.message}
                  </span>
                </div>
              </div>
            );
          } else {
            return (
              <div style={{ 
                padding: "12px 16px",
                fontSize: "14px",
                minHeight: "44px",
                lineHeight: "1.4",
                borderBottom: `1px solid ${theme.mode === 'dark' ? '#374151' : '#f0f0f0'}`, // ✅ USA TEMA
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                color: theme.mode === 'dark' ? '#f9fafb' : '#1f2937', // ✅ USA TEMA
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = theme.mode === 'dark' ? '#374151' : '#f8f9fa'; // ✅ USA TEMA
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = 'transparent';
              }}
              >
                {option}
              </div>
            );
          }
        }}
        // ✅ INDICADOR CUANDO NO HAY OPCIONES DISPONIBLES
        noOptionsText={
          <div style={{ 
            padding: "16px",
            textAlign: "center",
            color: theme.mode === 'dark' ? '#9ca3af' : "#666", // ✅ USA TEMA
            fontSize: "14px"
          }}>
            <span role="img" aria-label="búsqueda">🔍</span> No se encontraron respuestas rápidas
          </div>
        }
        onChange={(event, opt) => {
         
          if (isObject(opt) && has(opt, "value")) {
            setPopupOpen(false);
            setInputMessage(`/${String(opt.shortcode || "").trim()}` || opt.value);
            setTimeout(() => {
              if (inputRef.current) {
                inputRef.current.scrollTop = inputRef.current.scrollHeight;
                inputRef.current.focus();
              }
            }, 200);
          }
        }}
        onInputChange={(event, opt, reason) => {
          if (reason === "input") {
            setInputMessage(event.target.value);
          }
        }}
        onPaste={onPaste}
        onKeyDown={onKeyDown}
        style={{ width: "100%" }}
        // ✅ CORREGIDO: Deshabilitar manejo de teclado del Autocomplete cuando no hay popup
        ListboxProps={{
          onKeyDown: (e) => {
            // ✅ Solo manejar teclado cuando el popup está abierto
            if (popupOpen) {
              return;
            }
            // ✅ Para el resto, permitir navegación normal
            e.stopPropagation();
          }
        }}
        renderInput={(params) => {
          const { InputLabelProps, InputProps, ...rest } = params;
          return (
            <InputBase
              {...params.InputProps}
              {...rest}
              disabled={disableOption()}
              inputRef={setInputRef}
              placeholder={renderPlaceholder()}
              multiline
              className={classes.messageInput}
              maxRows={5}
              onKeyDown={onKeyDown}
            />
          );
        }}
      />
    </div>
  );
};

const MessageInputCustom = (props) => {

  const { ticketStatus, ticketId, ticket, width } = props; // width: withWidth — menú compacto en móvil
  const isMobileCompact = !isWidthUp("sm", width);
  const classes = useStyles();
  const theme = useTheme(); // ✅ NUEVO: Para acceder al tema en estilos inline

  const [medias, setMedias] = useState([]);
  /** Leyenda por índice de archivo (misma UX que WhatsApp Web al cambiar miniatura). */
  const [mediaCaptions, setMediaCaptions] = useState([]);
  const [activeMediaIndex, setActiveMediaIndex] = useState(0); // ✅ ESTADO PARA ARCHIVO ACTIVO
  const [inputMessage, setInputMessage] = useState("");
  const [showEmoji, setShowEmoji] = useState(false);
  const [loading, setLoading] = useState(false);
  /** 0293 B: envío de texto en vuelo — no bloquea el input (no va en disableOption). */
  const [sendingText, setSendingText] = useState(false);
  const [recording, setRecording] = useState(false);
  const [quickMessages, setQuickMessages] = useState([]);
  const [options, setOptions] = useState([]);
  const [popupOpen, setPopupOpen] = useState(false);
  const [quickMessageDialogOpen, setQuickMessageDialogOpen] = useState(false);
  const matchedQuickMedia = useMemo(() => {
    const raw = String(inputMessage || "").trim();
    if (!raw.startsWith("/")) return null;
    const shortcut = raw.replace(/^\/+/, "").trim().toLowerCase();
    if (!shortcut) return null;
    return (
      quickMessages.find((option) => {
        const code = String(option?.shortcode || "").trim().toLowerCase();
        const media = option?.mediaPath;
        return (
          code === shortcut &&
          media &&
          media !== "null" &&
          media !== "undefined"
        );
      }) || null
    );
  }, [inputMessage, quickMessages]);
  const [fileLists, setFileLists] = useState([]);
  const [fileListOptions, setFileListOptions] = useState([]);
  const [fileListAnchorEl, setFileListAnchorEl] = useState(null);
  const [mobileComposerMenuAnchor, setMobileComposerMenuAnchor] = useState(null);
  const mobileFabRef = useRef(null);
  const [isDragOver, setIsDragOver] = useState(false);
  const [uploadProgress, setUploadProgress] = useState({});
  const inputRef = useRef();
  const mediaCaptionInputRef = useRef(null);
  const textDrainChainRef = useRef(Promise.resolve());
  /** Cola FIFO: envíos de texto encadenados tras limpiar el input (0298 Tarea 3). */
  const pendingTextJobsRef = useRef(0);
  const { setReplyingMessage, replyingMessage } =
    useContext(ReplyMessageContext);
  const { user } = useContext(AuthContext);
  const socketManager = useContext(SocketContext);
  const [quickMessagesTick, setQuickMessagesTick] = useState(0);

  // ✅ NUEVO: Función para detectar si el ticket tiene IA configurada
  const isAIAgent = (ticket) => {
    if (!ticket) return false;
    return ticket.promptId != null || 
           ticket.chatbot === true || 
           ticket.useIntegration === true;
  };

  // ✅ NUEVO: Determinar si el MessageInput debe estar bloqueado
  const isMessageInputBlocked = () => {
    if (!ticket) return false;
    
    // ✅ Si el ticket tiene IA configurada, bloquear el input
    if (isAIAgent(ticket)) {
      return true;
    }
    
    // ✅ Si el ticket está en estado "closed", bloquear el input
    if (ticketStatus === "closed") {
      return true;
    }
    
    // ✅ En todos los demás casos, permitir el input
    return false;
  };

  const [signMessage, setSignMessage] = useLocalStorage("signOption", true);

  const {
    selectedMessages,
    setForwardMessageModalOpen,
    showSelectMessageCheckbox,
    setShowSelectMessageCheckbox,
    setSelectedMessages } = useContext(ForwardMessageContext);

  const { list: listQuickMessages } = useQuickMessages();
  const { list: listFiles } = useFiles();

  // Cargar respuestas rápidas
  useEffect(() => {
    if (!user?.id) return;

    async function fetchData() {
      try {
        const messages = await listQuickMessages({ userId: user.id });
        const options = messages.map((m) => {
          const message = renderQuickMessageText(m.message, ticket);
          let truncatedMessage = message;
          if (isString(truncatedMessage) && truncatedMessage.length > 35) {
            truncatedMessage = message.substring(0, 35) + "...";
          }
          return {
            value: message,
            label: `/${String(m.shortcode || "").trim()} ${truncatedMessage}`,
            shortcode: String(m.shortcode || "").trim(),
            message,
            mediaPath: m.mediaPath,
            mediaName: m.mediaName,
          };
        });
        setQuickMessages(options);
      } catch (err) {
        setQuickMessages([]);
        toastError(err);
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.id, ticket?.id, ticket?.contact?.id, ticket?.contact?.name, ticket?.contact?.number, ticket?.contact?.email, quickMessagesTick]);

  useEffect(() => {
    if (!user?.companyId || !socketManager) return undefined;
    const socket = socketManager.getSocket(user.companyId);
    const eventName = `company-${user.companyId}-quickMessage`;
    const handler = () => setQuickMessagesTick((n) => n + 1);
    socket.on(eventName, handler);
    return () => {
      if (socket && typeof socket.off === "function") {
        socket.off(eventName, handler);
      }
    };
  }, [socketManager, user?.companyId]);

  // Cargar listas de archivos
  useEffect(() => {
    async function fetchFileLists() {
      const companyId = localStorage.getItem("companyId");
      const files = await listFiles({ companyId, userId: user.id });
      const options = files.map((fileList) => {
        let truncatedName = fileList.name;
        if (isString(truncatedName) && truncatedName.length > 35) {
          truncatedName = fileList.name.substring(0, 35) + "...";
        }
        return {
          value: fileList,
          label: `📁 ${truncatedName}`,
          name: fileList.name,
          message: fileList.message,
          options: fileList.options,
        };
      });
      setFileLists(options);
    }
    fetchFileLists();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Manejar autocompletado de respuestas rápidas
  useEffect(() => {
    if (
      isString(inputMessage) &&
      !isEmpty(inputMessage) &&
      inputMessage.startsWith("/")
    ) {
      setPopupOpen(true);

      // Si solo hay "/", mostrar todas las opciones
      if (inputMessage === "/") {
        setOptions(quickMessages);
      } else {
        // Filtrar por lo que se escriba después de "/"
        const searchTerm = inputMessage.substring(1).toLowerCase();
        const filteredOptions = quickMessages.filter(
          (m) => 
            m.shortcode.toLowerCase().includes(searchTerm) ||
            m.message.toLowerCase().includes(searchTerm)
        );
        setOptions(filteredOptions);
      }
    } else {
      setPopupOpen(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputMessage]);

  useEffect(() => {
    inputRef.current.focus();
  }, [replyingMessage]);

  useEffect(() => {
    inputRef.current.focus();
    return () => {
  
      setInputMessage("");
      setShowEmoji(false);
      setMedias([]);
      setMediaCaptions([]);
      setReplyingMessage(null);
    };
  }, [ticketId, setReplyingMessage]);

  useEffect(() => {
    textDrainChainRef.current = Promise.resolve();
    pendingTextJobsRef.current = 0;
    setSendingText(false);
  }, [ticketId]);

  // ✅ EFFECT PARA ESCUCHAR TECLA ESCAPE Y CANCELAR
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape' && medias.length > 0) {
        handleCancelAll();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [medias.length]);

  /** Al abrir la vista de adjuntos, foco en el caption (estilo WhatsApp Web). */
  const prevMediasLenCaptionRef = useRef(0);
  useEffect(() => {
    if (medias.length === 0) {
      prevMediasLenCaptionRef.current = 0;
      return;
    }
    const prev = prevMediasLenCaptionRef.current;
    prevMediasLenCaptionRef.current = medias.length;
    if (prev === 0) {
      const tid = setTimeout(() => {
        mediaCaptionInputRef.current?.focus?.();
      }, 120);
      return () => clearTimeout(tid);
    }
  }, [medias.length]);

  // const handleChangeInput = e => {
  // 	if (isObject(e) && has(e, 'value')) {
  // 		setInputMessage(e.value);
  // 	} else {
  // 		setInputMessage(e.target.value)
  // 	}
  // };

  const handleOpenModalForward = () => {
    if (selectedMessages.length === 0) {
      setForwardMessageModalOpen(false)
      toastError(i18n.t("messagesList.header.notMessage"));
      return;
    }
    setForwardMessageModalOpen(true);
  }

  const handleAddEmoji = (e) => {
    let emoji = e.native;
    setInputMessage((prevState) => prevState + emoji);
  };

  const handleChangeMedias = async (e) => {
    if (!e.target.files) {
      return;
    }

    const selectedMedias = Array.from(e.target.files);
    e.target.value = "";
    const validMedias = [];

    for (const media of selectedMedias) {
      if (validateFileSize(media)) {
        validMedias.push(await prepareOutgoingFile(media));
      }
    }

    if (validMedias.length > 0) {
      setMedias(prevMedias => {
        const newMedias = [...prevMedias, ...validMedias];
        setActiveMediaIndex(newMedias.length - 1);
        return newMedias;
      });
      setMediaCaptions(prev => [
        ...prev,
        ...validMedias.map(() => ""),
      ]);
    }
  };

  /** Solo la primera imagen del portapapeles por evento (evita PNG+HTML duplicado y doble burbuja onPaste). */
  const handleInputPaste = (e) => {
    const items = e.clipboardData.items;
    if (!items) return;

    let fileToAdd = null;
    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      if (item.type.indexOf("image") !== -1) {
        const file = item.getAsFile();
        if (file && validateFileSize(file)) {
          fileToAdd = file;
          break;
        }
      }
    }
    if (!fileToAdd) return;

    if (typeof e.preventDefault === "function") e.preventDefault();
    if (typeof e.stopPropagation === "function") e.stopPropagation();

    setMedias((prevMedias) => {
      const newMedias = [...prevMedias, fileToAdd];
      setActiveMediaIndex(newMedias.length - 1);
      return newMedias;
    });
    setMediaCaptions((prev) => [...prev, ""]);
  };

  /** Vista multimedia: pegar imagen añade archivo; pegar texto va al caption (comportamiento tipo WhatsApp Web). */
  const handleMediaCaptionPaste = (e) => {
    if (ticketStatus !== "open") return;
    const items = e.clipboardData?.items;
    if (!items) return;
    for (let i = 0; i < items.length; i++) {
      if (items[i].type.indexOf("image") !== -1) {
        e.preventDefault();
        e.stopPropagation();
        handleInputPaste(e);
        return;
      }
    }
  };

  // ✅ MEJORA: Drag & Drop múltiple
  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragOver(true);
  };

  const handleDragEnter = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragOver(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!e.currentTarget.contains(e.relatedTarget)) {
      setIsDragOver(false);
    }
  };

  const handleDrop = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragOver(false);
    
    const files = Array.from(e.dataTransfer.files);
    const validFiles = [];

    for (const file of files) {
      if (validateFileSize(file)) {
        validFiles.push(await prepareOutgoingFile(file));
      }
    }
    
    // ✅ SOLO AGREGAR ARCHIVOS VÁLIDOS A LA LISTA
    if (validFiles.length > 0) {
      setMedias(prevMedias => {
        const newMedias = [...prevMedias, ...validFiles];
        setActiveMediaIndex(newMedias.length - 1);
        return newMedias;
      });
      setMediaCaptions(prev => [
        ...prev,
        ...validFiles.map(() => ""),
      ]);
    }
  };

  // ✅ MEJORA: Eliminar archivo específico
  const handleRemoveMedia = (indexToRemove) => {
    setMedias(prevMedias => {
      const newMedias = prevMedias.filter((_, index) => index !== indexToRemove);
      
      // ✅ AJUSTAR ÍNDICE ACTIVO DESPUÉS DE ELIMINAR
      if (newMedias.length === 0) {
        setActiveMediaIndex(0);
      } else if (activeMediaIndex >= newMedias.length) {
        setActiveMediaIndex(newMedias.length - 1);
      } else if (activeMediaIndex > indexToRemove) {
        setActiveMediaIndex(activeMediaIndex - 1);
      }
      
      return newMedias;
    });
    setMediaCaptions(prev =>
      prev.filter((_, index) => index !== indexToRemove),
    );
  };

  // ✅ FUNCIÓN PARA CAMBIAR ARCHIVO ACTIVO
  const handleSelectActiveMedia = (index) => {
    if (index >= 0 && index < medias.length) {
      setActiveMediaIndex(index);
      setTimeout(() => mediaCaptionInputRef.current?.focus?.(), 0);
    }
  };

  // ✅ FUNCIÓN PARA CANCELAR Y LIMPIAR TODA LA LISTA
  const handleCancelAll = () => {
    setMedias([]);
    setMediaCaptions([]);
    setActiveMediaIndex(0);
    setUploadProgress({});
  };

  // ✅ VALIDACIÓN INMEDIATA DE ARCHIVOS (ESTILO WHATSAPP WEB)
  const validateFileSize = (file) => {
    const whatsappLimits = {
      audio: 16 * 1024 * 1024,    // 16MB
      video: 16 * 1024 * 1024,    // 16MB  
      image: 5 * 1024 * 1024,     // 5MB
      document: 100 * 1024 * 1024 // 100MB
    };
    
    const fileType = file.type.split('/')[0];
    const fileSizeMB = (file.size / (1024 * 1024)).toFixed(1);
    const limitMB = (whatsappLimits[fileType] / (1024 * 1024)).toFixed(0);
    
    // ✅ VERIFICAR LÍMITES ANTES DE AGREGAR A LA LISTA
    if (file.size > whatsappLimits[fileType]) {
      const errorMessage = `⚠️ ARCHIVO DEMASIADO GRANDE\n\n` +
        `📁 Archivo: ${file.name}\n` +
        `📊 Tamaño: ${fileSizeMB}MB\n` +
        `🚫 Límite WhatsApp: ${limitMB}MB\n\n` +
        `💡 SOLUCIONES:\n` +
        `• Comprimir el archivo a menos de ${limitMB}MB\n` +
        `• Usar un servicio de almacenamiento (Google Drive, Dropbox)\n` +
        `• Dividir el archivo en partes más pequeñas\n\n` +
        `ℹ️ Los límites de WhatsApp son:\n` +
        `• Audio: 16MB máximo\n` +
        `• Video: 16MB máximo\n` +
        `• Imagen: 5MB máximo\n` +
        `• Documento: 100MB máximo`;
      
      // ✅ MOSTRAR NOTIFICACIÓN PERSISTENTE (ESTILO WHATSAPP WEB)
      toast.error(errorMessage, {
        toastId: `file-too-large-${file.name}`,
        autoClose: false, // ✅ NO CERRAR AUTOMÁTICAMENTE
        hideProgressBar: true,
        closeOnClick: false, // ✅ NO CERRAR AL HACER CLIC
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        style: {
          backgroundColor: '#ff4444',
          color: '#ffffff',
          fontSize: '14px',
          fontWeight: 'bold',
          maxWidth: '400px',
          whiteSpace: 'pre-line'
        }
      });
      
      return false; // ✅ ARCHIVO RECHAZADO
    }
    
    return true; // ✅ ARCHIVO VÁLIDO
  };

  // ✅ MEJORA: Función para obtener el tipo de archivo
  const getFileType = (file) => {
    const type = String(file?.type || "");
    if (isChatImage(file)) return <span role="img" aria-label="imagen">🖼️</span>;
    if (type.startsWith('video/')) return <span role="img" aria-label="video">🎥</span>;
    if (type.startsWith('audio/')) return <span role="img" aria-label="audio">🎵</span>;
    if (type.includes('pdf')) return <span role="img" aria-label="documento pdf">📄</span>;
    if (type.includes('document') || type.includes('word')) return <span role="img" aria-label="documento">📝</span>;
    if (type.includes('sheet') || type.includes('excel')) return <span role="img" aria-label="hoja de cálculo">📊</span>;
    return <span role="img" aria-label="archivo">📎</span>;
  };

  const handleUploadQuickMessageMedia = async (blob, originalFileName, messageText = null) => {
    try {
      if (logger && logger.media) {
        logger.media.debug("Procesando multimedia para envío, tipo:", blob.type);
        logger.media.debug("Nombre original del archivo:", originalFileName);
        logger.media.debug("Texto del mensaje:", messageText);
      }
      
      // Mantener el nombre original del archivo
      let filename = originalFileName;
      
      // Si el nombre es muy extenso (más de 50 caracteres), truncarlo
              if (filename && filename.length > 50) {
          const extension = filename.split('.').pop();
          const nameWithoutExt = filename.substring(0, filename.lastIndexOf('.'));
          const truncatedName = nameWithoutExt.substring(0, 47) + '...';
          filename = `${truncatedName}.${extension}`;
          if (logger && logger.media) {
            logger.media.debug("Nombre truncado:", filename);
          }
        }
        
        // Si no hay nombre original, generar uno con timestamp
        if (!filename) {
          const extension = blob.type.split("/")[1] || 'bin';
          filename = `${new Date().getTime()}.${extension}`;
          if (logger && logger.media) {
            logger.media.debug("Nombre generado:", filename);
          }
        }
        
        if (logger && logger.media) {
          logger.media.debug("Nombre final del archivo:", filename);
        }

        const formData = new FormData();
        formData.append("medias", blob, filename);
        // ✅ Enviar SOLO multimedia. Si hay texto (caption) definido por el usuario, enviarlo.
        if (messageText && String(messageText).trim()) {
          formData.append("body", String(messageText).trim());
        }
        formData.append("fromMe", true);

        if (logger && logger.media) {
          logger.media.debug("Enviando multimedia al servidor...");
        }
        
        await api.post(`/messages/${ticketId}`, formData);
        
        if (logger && logger.media) {
          logger.media.info("Multimedia enviada exitosamente");
        }
      } catch (err) {
        if (logger && logger.media) {
          logger.media.error("Error al enviar multimedia:", err);
        }
        toastError(err);
        throw err; // Re-lanzar el error para que lo maneje la función padre
      }
  };
  
  const handleQuickAnswersClick = async (value) => {
    if (value.mediaPath) {
      setLoading(true);
      try {
        if (logger && logger.media) {
          logger.media.debug("Descargando multimedia desde:", value.mediaPath);
          logger.media.debug("URL completa:", value.mediaPath);
        }
        
        // ✅ Validar que la URL sea válida
        if (!value.mediaPath || value.mediaPath === 'null' || value.mediaPath === 'undefined' || value.mediaPath.includes('undefined')) {
          if (logger && logger.media) {
            logger.media.warn("URL de multimedia inválida:", value.mediaPath);
          }
          toastError(new Error("URL de multimedia inválida - Contacte al administrador"));
          setLoading(false);
          setInputMessage(value.value);
          return;
        }
        
        const { data } = await axios.get(value.mediaPath, {
          responseType: "blob",
          timeout: 10000, // 10 segundos de timeout
        });

        if (logger && logger.media) {
          logger.media.debug("Multimedia descargada exitosamente, tamaño:", data.size);
        }
        
        // ✅ EXTRAER NOMBRE REAL DEL ARCHIVO DESDE LA URL
        let fileName = value.value; // Fallback al texto de respuesta rápida
        
        if (value.mediaPath) {
          // Extraer nombre desde la URL del archivo
          const urlParts = value.mediaPath.split('/');
          const lastPart = urlParts[urlParts.length - 1];
          
          if (lastPart && lastPart.includes('.')) {
            fileName = lastPart;
            if (logger && logger.media) {
              logger.media.debug("Nombre extraído desde URL:", fileName);
            }
          }
        }
        
        // ✅ CORRECTO: Pasar el texto del mensaje junto con la imagen
        await handleUploadQuickMessageMedia(data, fileName, value.value);
        setInputMessage("");
        setLoading(false);
        return;
      } catch (err) {
        console.error("Error al procesar multimedia de respuesta rápida:", err);
        console.error("URL que falló:", value.mediaPath);
        
        // Mostrar error más específico
        let errorMessage = "Error al procesar multimedia";
        if (err.response) {
          if (err.response.status === 404) {
            errorMessage = "Archivo multimedia no encontrado";
          } else if (err.response.status === 403) {
            errorMessage = "Sin permisos para acceder al archivo";
          } else {
            errorMessage = `Error del servidor: ${err.response.status}`;
          }
        } else if (err.code === 'ECONNABORTED') {
          errorMessage = "Tiempo de espera agotado";
        }
        
        toastError(new Error(errorMessage));
        setLoading(false);
        
        // Si falla la multimedia, al menos enviar el texto
        setInputMessage(value.value);
        return;
      }
    }

    setInputMessage("");
    setInputMessage(value.value);
  };

  const handleFileListClick = async (value) => {
    if (logger && logger.media) {
      logger.media.debug("Valor recibido en handleFileListClick:", value);
    }
    
    // Verificar si value.value.options existe (estructura correcta)
    if (!value.value || !value.value.options || value.value.options.length === 0) {
      if (logger && logger.media) {
        logger.media.warn("No hay archivos en la lista. value.value:", value.value);
      }
      toastError("Esta lista de archivos no contiene archivos");
      return;
    }

    setLoading(true);
    try {
      if (logger && logger.media) {
        logger.media.debug("Enviando lista de archivos:", value.name);
        logger.media.debug("Archivos en la lista:", value.value.options.length);
      }

      // Enviar cada archivo de la lista
      for (const fileOption of value.value.options) {
        try {
          if (logger && logger.media) {
            logger.media.debug("Procesando archivo:", fileOption.name);
          }
          
          // Construir URL del archivo
          const publicFolder = "public/fileList";
          const backendUrl = process.env.REACT_APP_BACKEND_URL || window.location.origin;
          if (!backendUrl) {
            throw new Error('REACT_APP_BACKEND_URL no está configurado');
          }
          const fileUrl = `${backendUrl}/${publicFolder}/${value.value.id}/${fileOption.path}`;
          
          if (logger && logger.media) {
            logger.media.debug("URL del archivo:", fileUrl);
          }
          
          // Extraer nombre del archivo desde la ruta
          const fileName = fileOption.path || fileOption.name || 'documento';
          if (logger && logger.media) {
            logger.media.debug("Nombre del archivo extraído:", fileName);
          }
          
          // Descargar archivo
          const { data } = await axios.get(fileUrl, {
            responseType: "blob",
            timeout: 10000,
          });

          if (logger && logger.media) {
            logger.media.debug("Archivo descargado:", fileName, "tamaño:", data.size);
          }
          
          // Enviar archivo
          await handleUploadQuickMessageMedia(data, fileName);
          
          // Pequeña pausa entre archivos para no sobrecargar
          await new Promise(resolve => setTimeout(resolve, 500));
          
        } catch (err) {
          if (logger && logger.media) {
            logger.media.error("Error procesando archivo:", fileOption.name, err);
          }
          toastError(`Error al procesar archivo: ${fileOption.name}`);
        }
      }
      
      if (logger && logger.media) {
        logger.media.info("Lista de archivos enviada exitosamente");
      }
      setLoading(false);
      
    } catch (err) {
      if (logger && logger.media) {
        logger.media.error("Error al enviar lista de archivos:", err);
      }
      toastError("Error al enviar lista de archivos");
      setLoading(false);
    }
  };

  const handleUploadMedia = async (e) => {
    setLoading(true);
    e.preventDefault();

    const internalSignatureEnabled = await fetchInternalSignatureEnabled(api);

    // ✅ NUEVO: Crear mensaje interno con el nombre del usuario si está activada (solo una vez antes del primer archivo)
    if (internalSignatureEnabled && user?.name && medias.length > 0) {
      try {
        const internalMessage = {
          read: 1,
          fromMe: true,
          mediaUrl: "",
          body: user.name, // ✅ Nombre dinámico del usuario actual
          mediaType: "internal_signature", // ✅ Nuevo tipo de mensaje interno
          quotedMsg: null,
        };
        await api.post(`/messages/${ticketId}`, internalMessage);
      } catch (err) {
        // No fallar si no se puede crear el mensaje interno
        console.error("Error creando mensaje interno:", err);
      }
    }

    // ✅ SI TODOS LOS ARCHIVOS SON VÁLIDOS, CONTINUAR CON EL ENVÍO
    // ✅ MEJORA: Enviar cada archivo por separado
    const failedMedias = [];
    const failedCaptions = [];
    for (let i = 0; i < medias.length; i++) {
      const media = medias[i];
      const currentIndex = i; // Capturar el índice para evitar problemas de closure
      const rawCaption = (mediaCaptions[i] ?? "").trim();
      const captionBody = rawCaption
        ? signMessage && user?.name
          ? `*${user.name}:*\n${rawCaption}`
          : rawCaption
        : "";

      try {
        // Actualizar progreso
        setUploadProgress(prev => ({
          ...prev,
          [currentIndex]: 0
        }));

        if (isChatImage(media)) {
          // ✅ MEJORA: Manejar compresión de imágenes correctamente
          await new Promise((resolve, reject) => {
            new Compressor(media, {
              quality: 0.7,
              async success(compressedMedia) {
                try {
                  const formData = new FormData();
                  formData.append("fromMe", true);
                  formData.append("medias", compressedMedia, uploadNameFor(media));
                  // ✅ Enviar SOLO multimedia. Si hay caption, enviarlo.
                  if (captionBody) {
                    formData.append("body", captionBody);
                  }

                  await api.post(`/messages/${ticketId}`, formData, {
                    onUploadProgress: (event) => {
                      const progress = Math.round((event.loaded * 100) / event.total);
                      setUploadProgress(prev => ({
                        ...prev,
                        [currentIndex]: progress
                      }));
                    },
                  });

                  resolve();
                } catch (err) {
                  reject(err);
                }
              },
              error(err) {
                (async () => {
                  try {
                    const formData = new FormData();
                    formData.append("fromMe", true);
                    formData.append("medias", media, uploadNameFor(media));
                    if (captionBody) formData.append("body", captionBody);
                    await api.post(`/messages/${ticketId}`, formData);
                    resolve();
                  } catch (sendErr) {
                    reject(sendErr || err);
                  }
                })();
              },
            });
          });
        } else {
          // ✅ MEJORA: Enviar archivos no-imagen directamente
          const prepared = await prepareOutgoingFile(media);
          const formData = new FormData();
          formData.append("fromMe", true);
          formData.append("medias", prepared, uploadNameFor(prepared, media.name || "file"));
          // ✅ Enviar SOLO multimedia. Si hay caption, enviarlo.
          if (captionBody) {
            formData.append("body", captionBody);
          }
          // ✅ AGREGAR: Tamaño del archivo para el backend
          formData.append("fileSize", media.size);
          formData.append("fileName", media.name);

          await api.post(`/messages/${ticketId}`, formData, {
            onUploadProgress: (event) => {
              const progress = Math.round((event.loaded * 100) / event.total);
              setUploadProgress(prev => ({
                ...prev,
                [currentIndex]: progress
              }));
            },
          });
        }
      } catch (err) {
        toastError(err);
        failedMedias.push(media);
        failedCaptions.push(mediaCaptions[i] ?? "");
      }
    }

    setLoading(false);
    setMedias(failedMedias);
    setMediaCaptions(failedCaptions);
    setUploadProgress({});
  }

  const runTextSendJob = async ({
    enqueueTicketId,
    trimmed,
    quotedSnapshot,
    signSnapshot,
    signerName,
  }) => {
    const bodyForApi =
      signSnapshot && signerName
        ? `*${signerName}:*\n${trimmed}`
        : trimmed;
    try {
      const internalSignatureEnabled = await fetchInternalSignatureEnabled(api);

      if (internalSignatureEnabled && signerName) {
        const internalMessage = {
          read: 1,
          fromMe: true,
          mediaUrl: "",
          body: signerName,
          mediaType: "internal_signature",
          quotedMsg: null,
        };
        await api.post(`/messages/${enqueueTicketId}`, internalMessage);
      }

      const message = {
        read: 1,
        fromMe: true,
        mediaUrl: "",
        body: bodyForApi,
        quotedMsg: quotedSnapshot,
      };
      await api.post(`/messages/${enqueueTicketId}`, message);

      setShowEmoji(false);
      setReplyingMessage(null);
    } catch (err) {
      toastError(err);
      setInputMessage((prev) =>
        prev && prev.trim() ? `${trimmed}\n${prev}` : trimmed
      );
    }
  };

  const handleSendMessage = async () => {
    let trimmed = inputMessage.trim();
    if (trimmed === "") return;

    if (trimmed.startsWith("/")) {
      const shortcut = trimmed.replace(/^\/+/, "").trim().toLowerCase();
      const quickMessage = quickMessages.find((option) =>
        String(option?.shortcode || "").trim().toLowerCase() === shortcut
      );

      if (quickMessage) {
        if (!isNil(quickMessage.mediaPath)) {
          setInputMessage("");
          await handleQuickAnswersClick(quickMessage);
          return;
        }
        trimmed = quickMessage.value;
        setPopupOpen(false);
      }
    }

    const quotedSnapshot = replyingMessage;
    const signSnapshot = signMessage;
    const signerName = user?.name || "";
    const enqueueTicketId = ticketId;

    setInputMessage("");

    pendingTextJobsRef.current += 1;
    setSendingText(true);

    textDrainChainRef.current = textDrainChainRef.current
      .then(() => runTextSendJob({
        enqueueTicketId,
        trimmed,
        quotedSnapshot,
        signSnapshot,
        signerName,
      }))
      .catch(() => {})
      .finally(() => {
        pendingTextJobsRef.current = Math.max(0, pendingTextJobsRef.current - 1);
        if (pendingTextJobsRef.current === 0) {
          setSendingText(false);
        }
      });
  };

  const handleStartRecording = async () => {
    setLoading(true);
    try {
      await navigator.mediaDevices.getUserMedia({ audio: true });
      await Mp3Recorder.start();
      setRecording(true);
      setLoading(false);
    } catch (err) {
      toastError(err);
      setLoading(false);
    }
  };

  const handleUploadAudio = async () => {
    setLoading(true);
    try {
      const [, blob] = await Mp3Recorder.stop().getMp3();
      if (blob.size < 10000) {
        setLoading(false);
        setRecording(false);
        return;
      }

      const formData = new FormData();
      const filename = `audio-record-site-${new Date().getTime()}.mp3`;
      formData.append("medias", blob, filename);
      formData.append("fromMe", true);
      // ✅ Enviar SOLO audio. Si el usuario escribió mensaje, enviarlo.
      const caption = inputMessage?.trim() || "";
      if (caption) {
        formData.append("body", signMessage ? `*${user?.name}:*\n${caption}` : caption);
        setInputMessage("");
      }

      await api.post(`/messages/${ticketId}`, formData);
    } catch (err) {
      toastError(err);
    }

    setRecording(false);
    setLoading(false);
  };

  const handleCancelAudio = async () => {
    try {
      await Mp3Recorder.stop().getMp3();
      setRecording(false);
    } catch (err) {
      toastError(err);
    }
  };

  const handleQuickReplyButtonClick = () => {
    setInputMessage("/");
    // Forzar que se muestren las opciones inmediatamente
    setTimeout(() => {
      setPopupOpen(true);
      setOptions(quickMessages);
    }, 100);
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  const handleFileListButtonClick = (event) => {
    setFileListAnchorEl(event.currentTarget);
    setFileListOptions(fileLists);
  };

  const handleFileListMenuClose = () => {
    setFileListAnchorEl(null);
  };

  const handleFileListSelect = (fileList) => {
    handleFileListClick(fileList);
    handleFileListMenuClose();
  };

  const closeMobileComposerMenu = () => setMobileComposerMenuAnchor(null);

  const mobilePickDocument = () => {
    closeMobileComposerMenu();
    const input = document.createElement("input");
    input.type = "file";
    input.multiple = true;
    input.accept = ".pdf,.doc,.docx,.xls,.xlsx,.txt,.ppt,.pptx";
    input.onchange = (e) => handleChangeMedias(e);
    input.click();
  };
  const mobilePickPhotoVideo = () => {
    closeMobileComposerMenu();
    const input = document.createElement("input");
    input.type = "file";
    input.multiple = true;
    input.accept = "image/*,video/*";
    input.onchange = (e) => handleChangeMedias(e);
    input.click();
  };
  const mobilePickAudio = () => {
    closeMobileComposerMenu();
    const input = document.createElement("input");
    input.type = "file";
    input.multiple = true;
    input.accept = "audio/*";
    input.onchange = (e) => handleChangeMedias(e);
    input.click();
  };
  const mobilePickContact = () => {
    closeMobileComposerMenu();
    console.log("Contactos - Por implementar");
  };

  const disableOption = () => {
    // ✅ Deshabilitar si está cargando (multimedia/grabación), grabando, o el ticket no está abierto
    // ✅ 0293 B: sendingText NO deshabilita — el usuario puede seguir escribiendo el siguiente mensaje
    if (loading || recording || ticketStatus !== "open") {
      return true;
    }
    
    // ✅ CRÍTICO: Deshabilitar si el ticket está en "pending" sin usuario asignado
    // Esto evita que el usuario escriba cuando el ticket está pendiente de aceptación
    if (ticketStatus === "pending" && (!ticket?.userId || ticket.userId === null)) {
      return true;
    }
    
    return false;
  };

  const renderReplyingMessage = (message) => {
    return (
      <div className={classes.replyginMsgWrapper}>
        <div className={classes.replyginMsgContainer}>
          <span
            className={clsx(classes.replyginContactMsgSideColor, {
              [classes.replyginSelfMsgSideColor]: !message.fromMe,
            })}
          ></span>
          <div className={classes.replyginMsgBody}>
            {!message.fromMe && (
              <span className={classes.messageContactName}>
                {message.contact?.name}
              </span>
            )}
            {message.body}
          </div>
        </div>
        <IconButton
          aria-label="showRecorder"
          component="span"
          disabled={loading || ticketStatus !== "open"}
          onClick={() => setReplyingMessage(null)}
        >
          <ClearIcon className={classes.sendMessageIcons} />
        </IconButton>
      </div>
    );
  };

  if (medias.length > 0)
    return (
      <Paper 
        elevation={0} 
        square 
        className={classes.viewMediaInputWrapper}
        onDragOver={handleDragOver}
        onDragEnter={handleDragEnter}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
        style={{
          border: isDragOver ? `2px dashed ${theme.palette.primary.main}` : "none",
          backgroundColor: isDragOver 
            ? (theme.mode === 'dark' ? 'rgba(59,130,246,0.12)' : "#f0f8ff") 
            : undefined,
          transition: "all 0.3s ease",
          position: "relative"
        }}
      >
        {/* Indicador de drag & drop para vista de archivos */}
        {isDragOver && (
          <div style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            background: "rgba(33, 150, 243, 0.9)",
            color: "white",
            padding: "20px",
            borderRadius: "10px",
            zIndex: 1000,
            pointerEvents: "none",
            fontSize: "16px",
            fontWeight: "bold",
            boxShadow: "0 4px 20px rgba(0,0,0,0.3)"
          }}>
            <span role="img" aria-label="carpeta">📁</span> SUELTA AQUÍ PARA ADJUNTAR MÁS ARCHIVOS - NUEVO
          </div>
        )}
        {/* ✅ INPUT OCULTO PARA EL BOTÓN "+" */}
        <input
          multiple
          type="file"
          id="upload-input"
          disabled={loading || recording || ticketStatus !== "open"}
          className={classes.uploadInput}
          onChange={handleChangeMedias}
          accept="image/*,video/*,audio/*,.pdf,.doc,.docx,.xls,.xlsx,.txt"
          style={{ display: 'none' }}
        />

        {/* ✅ INTERFAZ MEJORADA ESTILO WHATSAPP WEB CON NAVEGACIÓN FUNCIONAL - LAYOUT HORIZONTAL */}
        <div className={classes.mediaCompose}>
          <div className={classes.mediaThumbs}>
              {medias.map((media, index) => (
                <div key={index} style={{
                  position: 'relative',
                  width: '50px', // ✅ TAMAÑO REDUCIDO PARA LAYOUT HORIZONTAL
                  height: '50px', // ✅ TAMAÑO REDUCIDO PARA LAYOUT HORIZONTAL
                  backgroundColor: theme.mode === 'dark' ? '#374151' : '#fff', // ✅ USA TEMA
                  border: index === activeMediaIndex 
                    ? `3px solid ${theme.mode === 'dark' ? '#10b981' : '#25d366'}` 
                    : `2px solid ${theme.mode === 'dark' ? '#4B5563' : '#ddd'}`, // ✅ USA TEMA
                  borderRadius: '8px',
                  overflow: 'hidden',
                  cursor: 'pointer',
                  boxShadow: index === activeMediaIndex ? '0 4px 12px rgba(37, 211, 102, 0.3)' : '0 2px 4px rgba(0,0,0,0.1)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  transition: 'all 0.2s ease',
                  flexShrink: 0 // ✅ EVITAR QUE SE COMPRIMAN
                }}
                onClick={() => handleSelectActiveMedia(index)}
                >
                  {isChatImage(media) ? (
                    <img 
                      src={URL.createObjectURL(media)} 
                      alt={media.name}
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover'
                      }}
                    />
                  ) : (
                    <div style={{
                      fontSize: '20px', // ✅ TAMAÑO REDUCIDO
                      color: theme.mode === 'dark' ? '#9ca3af' : '#666' // ✅ USA TEMA
                    }}>
                      {getFileType(media)}
                    </div>
                  )}
                  
                  {/* ✅ BOTÓN ELIMINAR */}
                  <IconButton 
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleRemoveMedia(index);
                    }}
                    style={{
                      position: 'absolute',
                      top: '-4px',
                      right: '-4px',
                      backgroundColor: '#ff4444',
                      color: '#fff',
                      width: '18px',
                      height: '18px',
                      fontSize: '10px',
                      padding: '0',
                      boxShadow: '0 2px 4px rgba(0,0,0,0.3)'
                    }}
                  >
                    <CloseIcon fontSize="small" />
                  </IconButton>

                  {/* ✅ INDICADOR DE PROGRESO */}
                  {uploadProgress[index] !== undefined && (
                    <div style={{
                      position: 'absolute',
                      bottom: '0',
                      left: '0',
                      right: '0',
                      height: '3px',
                      backgroundColor: theme.mode === 'dark' ? '#4B5563' : '#e0e0e0', // ✅ USA TEMA
                      borderRadius: '0 0 8px 8px'
                    }}>
                      <div style={{
                        height: '100%',
                        backgroundColor: theme.mode === 'dark' ? '#10b981' : '#25d366', // ✅ USA TEMA
                        width: `${uploadProgress[index]}%`,
                        borderRadius: '0 0 8px 8px',
                        transition: 'width 0.3s ease'
                      }} />
                    </div>
                  )}
                </div>
              ))}

              {/* ✅ BOTÓN AGREGAR MÁS ARCHIVOS */}
              <div style={{
                width: '50px', // ✅ TAMAÑO REDUCIDO
                height: '50px', // ✅ TAMAÑO REDUCIDO
                backgroundColor: theme.mode === 'dark' ? '#374151' : '#f0f0f0', // ✅ USA TEMA
                border: `2px dashed ${theme.mode === 'dark' ? '#6B7280' : '#ccc'}`, // ✅ USA TEMA
                borderRadius: '8px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                flexShrink: 0 // ✅ EVITAR QUE SE COMPRIMA
              }}
              onClick={() => document.getElementById('upload-input')?.click()}
              >
                <div style={{
                  fontSize: '20px', // ✅ TAMAÑO REDUCIDO
                  color: theme.mode === 'dark' ? '#9ca3af' : '#666', // ✅ USA TEMA
                  fontWeight: 'bold'
                }}>
                  +
                </div>
              </div>
            </div>

            <div className={classes.mediaComposeRow}>
            {medias[activeMediaIndex] ? (
              <div className={classes.mediaCaptionWrap}>
                <TextField
                  inputRef={mediaCaptionInputRef}
                  fullWidth
                  multiline
                  minRows={1}
                  maxRows={4}
                  variant="outlined"
                  size="small"
                  placeholder={i18n.t(
                    "messagesInput.mediaCaptionPlaceholder",
                  )}
                  value={mediaCaptions[activeMediaIndex] ?? ""}
                  onChange={(e) => {
                    const v = e.target.value;
                    setMediaCaptions((prev) => {
                      const next = [...prev];
                      while (next.length <= activeMediaIndex)
                        next.push("");
                      next[activeMediaIndex] = v;
                      return next;
                    });
                  }}
                  onPaste={handleMediaCaptionPaste}
                  disabled={
                    loading || recording || ticketStatus !== "open"
                  }
                  InputProps={{
                    style: {
                      backgroundColor:
                        theme.mode === "dark" ? "#1f2937" : "#fff",
                      color:
                        theme.mode === "dark" ? "#f9fafb" : "#1f2937",
                      fontSize: 14,
                      alignItems: "center",
                    },
                  }}
                  inputProps={{
                    "aria-label": i18n.t(
                      "messagesInput.mediaCaptionPlaceholder",
                    ),
                  }}
                />
              </div>
            ) : null}

        <div className={classes.mediaComposeActions}>
          {/* ✅ BOTÓN CANCELAR */}
          <IconButton
            onClick={handleCancelAll}
            style={{
              backgroundColor: '#dc3545',
              color: '#fff',
              width: '36px',
              height: '36px',
              borderRadius: '50%',
            }}
            title="Cancelar y limpiar lista (ESC)"
          >
            ✕
          </IconButton>
          
          {/* ✅ BOTÓN ENVIAR */}
          <IconButton
            onClick={handleUploadMedia}
            disabled={loading || medias.length === 0}
            style={{
              backgroundColor: '#25d366',
              color: '#fff',
              width: '36px',
              height: '36px',
              borderRadius: '50%',
            }}
          >
            {loading ? (
              <CircularProgress size={20} color="inherit" />
            ) : (
              <SendIcon fontSize="small" />
            )}
          </IconButton>
        </div>
            </div>
      </div>
        
      </Paper>
    );
  else {
      // ✅ NUEVO: Verificar si el input debe estar bloqueado
      const blocked = isMessageInputBlocked();
      const isPending = ticket?.status === "pending";
      
      return (
        <Paper 
        square 
        elevation={0} 
        className={classes.mainWrapper}
        style={{
          opacity: blocked ? 0.5 : 1,
          pointerEvents: blocked ? 'none' : 'auto',
          position: 'relative'
        }}
      >
        {/* ✅ NUEVO: Mensaje de modo lectura cuando ticket está pending - PARTE INFERIOR */}
        {isPending && (
          <Box
            style={{
              padding: "12px 16px",
              backgroundColor: theme.mode === 'dark' ? '#1f2937' : "#fff3cd",
              borderTop: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#ffc107'}`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
              marginBottom: "8px"
            }}
          >
            <LockIcon style={{ 
              color: theme.mode === 'dark' ? '#fbbf24' : "#856404", 
              fontSize: "18px" 
            }} />
            <Typography
              variant="body2"
              style={{
                color: theme.mode === 'dark' ? '#fbbf24' : "#856404",
                fontWeight: "500",
                fontSize: "14px"
              }}
            >
              Modo lectura: Este ticket está pendiente. Debes aceptarlo para poder responder.
            </Typography>
          </Box>
        )}
        
        {/* ✅ NUEVO: Mensaje de bloqueo cuando ticket tiene IA */}
        {blocked && isAIAgent(ticket) && (
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000,
            borderRadius: '8px',
            border: '2px dashed #ff9800'
          }}>
            <div style={{
              textAlign: 'center',
              color: '#ff9800',
              fontWeight: 'bold',
              fontSize: '14px'
            }}>
              <span role="img" aria-label="robot">🤖</span> Este ticket está siendo atendido por un AGENTE IA<br/>
              <span style={{ fontSize: '12px', fontWeight: 'normal' }}>
                Los humanos no pueden intervenir en esta conversación
              </span>
            </div>
          </div>
        )}
        {replyingMessage && renderReplyingMessage(replyingMessage)}
        {matchedQuickMedia && (
          <Box px={1.5} pt={1} pb={0.5}>
            <AttachmentPreview
              mediaPath={matchedQuickMedia.mediaPath}
              mediaName={matchedQuickMedia.mediaName}
            />
          </Box>
        )}
        {!isMobileCompact && (
          <div className={classes.composerActions}>
            <FileInput
              disableOption={disableOption}
              handleChangeMedias={handleChangeMedias}
              hideTriggerButton={false}
              labeled
            />
            <SignSwitch
              width={props.width}
              setSignMessage={setSignMessage}
              signMessage={signMessage}
            />
            <Button
              className={classes.composerActionBtn}
              size="small"
              startIcon={<FlashOnIcon fontSize="small" />}
              disabled={disableOption()}
              onClick={handleQuickReplyButtonClick}
            >
              Respuestas Rápidas
            </Button>
          </div>
        )}
        <div 
          className={clsx(classes.newMessageBox, isMobileCompact && classes.newMessageBoxCompact)}
          onDragOver={handleDragOver}
          onDragEnter={handleDragEnter}
          onDragLeave={handleDragLeave}
          onDrop={handleDrop}
          style={{
            border: isDragOver ? `2px dashed ${theme.palette.primary.main}` : undefined,
            backgroundColor: isDragOver
              ? (theme.mode === "dark" ? "rgba(59,130,246,0.12)" : "#f0f8ff")
              : undefined,
            transition: "all 0.3s ease",
            position: "relative"
          }}
        >
          {/* Indicador de drag & drop */}
          {isDragOver && (
            <div style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              background: "rgba(33, 150, 243, 0.9)",
              color: "white",
              padding: "20px",
              borderRadius: "10px",
              zIndex: 1000,
              pointerEvents: "none",
              fontSize: "16px",
              fontWeight: "bold",
              boxShadow: "0 4px 20px rgba(0,0,0,0.3)"
            }}>
              <span role="img" aria-label="carpeta">📁</span> SUELTA AQUÍ PARA ADJUNTAR ARCHIVOS - NUEVO
            </div>
          )}
          {/* Móvil (sm-): un solo botón + con menú (emojis, adjuntos, respuestas rápidas, listas) */}
          {isMobileCompact && (
            <>
              <IconButton
                ref={mobileFabRef}
                aria-label="herramientas de mensaje"
                component="span"
                disabled={disableOption()}
                className={classes.mobileComposerFab}
                onClick={(e) => setMobileComposerMenuAnchor(e.currentTarget)}
                title="Emojis, adjuntos y más"
              >
                <AddIcon style={{ color: theme.mode === "dark" ? "white" : "#2196f3" }} />
              </IconButton>
              <Menu
                anchorEl={mobileComposerMenuAnchor}
                open={Boolean(mobileComposerMenuAnchor)}
                onClose={closeMobileComposerMenu}
                PaperProps={{
                  style: {
                    backgroundColor: theme.palette.background.paper,
                    borderRadius: "12px",
                    minWidth: 240,
                    maxHeight: "70vh",
                    border: `1px solid ${theme.mode === "dark" ? "#4B5563" : "#e0e0e0"}`,
                    boxShadow: theme.mode === "dark" ? "0 4px 20px rgba(0,0,0,0.5)" : "0 4px 20px rgba(0,0,0,0.15)",
                  },
                }}
                anchorOrigin={{ vertical: "top", horizontal: "left" }}
                transformOrigin={{ vertical: "bottom", horizontal: "left" }}
              >
                <MenuItem
                  onClick={() => {
                    setShowEmoji((p) => !p);
                    closeMobileComposerMenu();
                  }}
                >
                  <ListItemIcon>
                    <MoodIcon />
                  </ListItemIcon>
                  <ListItemText primary="Emojis" />
                </MenuItem>
                <Divider />
                <MenuItem onClick={mobilePickDocument}>
                  <ListItemIcon>
                    <DescriptionIcon style={{ color: "#9c27b0" }} />
                  </ListItemIcon>
                  <ListItemText primary="Documentos" />
                </MenuItem>
                <MenuItem onClick={mobilePickPhotoVideo}>
                  <ListItemIcon>
                    <PhotoCameraIcon style={{ color: "#2196f3" }} />
                  </ListItemIcon>
                  <ListItemText primary="Fotos y Videos" />
                </MenuItem>
                <MenuItem onClick={mobilePickAudio}>
                  <ListItemIcon>
                    <MicIcon style={{ color: "#ff9800" }} />
                  </ListItemIcon>
                  <ListItemText primary="Audio" />
                </MenuItem>
                <MenuItem onClick={mobilePickContact}>
                  <ListItemIcon>
                    <ContactPhoneIcon style={{ color: "#4caf50" }} />
                  </ListItemIcon>
                  <ListItemText primary="Contactos" />
                </MenuItem>
                <Divider />
                <MenuItem
                  onClick={() => {
                    closeMobileComposerMenu();
                    handleQuickReplyButtonClick();
                  }}
                >
                  <ListItemIcon>
                    <FlashOnIcon />
                  </ListItemIcon>
                  <ListItemText primary="Respuestas rápidas" />
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    closeMobileComposerMenu();
                    setTimeout(() => {
                      if (mobileFabRef.current) {
                        handleFileListButtonClick({ currentTarget: mobileFabRef.current });
                      }
                    }, 50);
                  }}
                >
                  <ListItemIcon>
                    <FolderIcon />
                  </ListItemIcon>
                  <ListItemText primary="Listas de archivos" />
                </MenuItem>
              </Menu>
            </>
          )}

          <EmojiOptions
            disabled={disableOption()}
            handleAddEmoji={handleAddEmoji}
            showEmoji={showEmoji}
            setShowEmoji={setShowEmoji}
            hideButton={isMobileCompact}
          />

          {!isMobileCompact && (
            <>
              <IconButton
                aria-label="fileLists"
                component="span"
                disabled={disableOption()}
                onClick={handleFileListButtonClick}
                title="Listas de Archivos"
                className={classes.composerIconBtn}
              >
                <FolderIcon />
              </IconButton>
            </>
          )}

          <Menu
            anchorEl={fileListAnchorEl}
            open={Boolean(fileListAnchorEl)}
            onClose={handleFileListMenuClose}
            PaperProps={{
              style: {
                maxHeight: 300,
                width: 300,
                backgroundColor: theme.mode === 'dark' ? '#1f2937' : '#ffffff', // ✅ USA TEMA
                border: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#e0e0e0'}`, // ✅ USA TEMA
                boxShadow: theme.mode === 'dark' ? '0 4px 20px rgba(0,0,0,0.5)' : '0 4px 20px rgba(0,0,0,0.15)', // ✅ USA TEMA
              },
            }}
          >
            {fileListOptions.map((fileList) => (
              <MenuItem
                key={fileList.value.id}
                onClick={() => handleFileListSelect(fileList)}
                style={{ 
                  display: 'flex', 
                  alignItems: 'center',
                  fontSize: '14px',
                  padding: '8px 16px',
                  color: theme.mode === 'dark' ? '#f9fafb' : '#1f2937', // ✅ USA TEMA
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = theme.mode === 'dark' ? '#374151' : '#f5f5f5'; // ✅ USA TEMA
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = 'transparent';
                }}
              >
                {fileList.label}
              </MenuItem>
            ))}
            {fileListOptions.length === 0 && (
              <MenuItem 
                disabled
                style={{
                  color: theme.mode === 'dark' ? '#6b7280' : '#9e9e9e', // ✅ USA TEMA
                }}
              >
                No hay listas de archivos disponibles
              </MenuItem>
            )}
          </Menu>

          {isMobileCompact && (
          <SignSwitch
            width={props.width}
            setSignMessage={setSignMessage}
            signMessage={signMessage}
          />
          )}

          <CustomInput
            loading={loading}
            inputRef={inputRef}
            ticketStatus={ticketStatus}
            inputMessage={inputMessage}
            setInputMessage={setInputMessage}
            // handleChangeInput={handleChangeInput}
            handleSendMessage={handleSendMessage}
            handleInputPaste={handleInputPaste}
            disableOption={disableOption}
            replyingMessage={replyingMessage}
            handleQuickAnswersClick={handleQuickAnswersClick}
            options={options}
            popupOpen={popupOpen}
            setPopupOpen={setPopupOpen}
            onAddQuickMessage={() => setQuickMessageDialogOpen(true)}
            inputWrapperClassName={isMobileCompact ? classes.messageInputWrapperGrow : undefined}
          />

          <QuickMessageDialog
            open={quickMessageDialogOpen}
            onClose={() => setQuickMessageDialogOpen(false)}
            reload={() => setQuickMessagesTick((n) => n + 1)}
          />

          <ActionButtons
            inputMessage={inputMessage}
            loading={loading}
            sendingText={sendingText}
            recording={recording}
            ticketStatus={ticketStatus}
            handleSendMessage={handleSendMessage}
            handleCancelAudio={handleCancelAudio}
            handleUploadAudio={handleUploadAudio}
            handleStartRecording={handleStartRecording}
            handleOpenModalForward={handleOpenModalForward}
            showSelectMessageCheckbox={showSelectMessageCheckbox}
            setShowSelectMessageCheckbox={setShowSelectMessageCheckbox}
            setSelectedMessages={setSelectedMessages}
          />
        </div>
      </Paper>
    );
  }
};

export default withWidth()(MessageInputCustom);
